// NoteTooltip.jsx
import React from "react";
import { useTranslation } from "react-i18next";

const NoteTooltip = ({ notes, userRole, stageName }) => {
  const { t } = useTranslation();
  const user = JSON.parse(sessionStorage.getItem("userDetails"))?.result;
  const canSeeProcessNote =
    user?.role?.id === 1 ||
    user?.role?.id === 2 ||
    user?.role?.id === 4 ||
    user?.role?.id === 5 ||
    (user?.role?.id === 3 && user?.loggedinprofiletype === "sellerprofile");

  // Helper function to check if user can see note type
  const canSeeNoteType = (noteType) => {
    if (noteType === "process") {
      return true;
      // return ["partner", "representatives", "admin"].includes(
      //   userRole?.toLowerCase()
      // );
    }
    return true; // Information notes visible to all
  };

  // Get visible notes
  const visibleNotes = [];

  if (notes.process && canSeeNoteType("process")) {
    visibleNotes.push({
      type: "process",
      label: t("processNoteLabel"),
      ...notes.process,
    });
  }

  if (notes.information && canSeeNoteType("information")) {
    visibleNotes.push({
      type: "information",
      label: t("infoNoteLabel"),
      ...notes.information,
    });
  }

  // Don't render if no visible notes
  if (visibleNotes.length === 0) return null;

  const formatTimestamp = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(timestamp);
    return (
      date.toLocaleDateString() +
      " " +
      date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      })
    );
  };

  return (
    <div className="note-tooltip">
      <div className="note-tooltip-content">
        <div className="note-tooltip-header">
          <strong>
            {stageName} - {t("notes")}
          </strong>
        </div>

        {visibleNotes.map((note, index) => (
          <div key={note.type} className={`note-item ${note.type}`}>
            {canSeeProcessNote && note.type === "process" && (
              <div>
                <div className="note-type-label">
                  <span className={`note-type-indicator ${note.type}`}>
                    {note.type === "process" ? "P" : "i"}
                  </span>
                  {note.label}
                </div>
                <div className="note-text">{note.text}</div>
                {note.timestamp && (
                  <div className="note-meta">
                    {formatTimestamp(note.timestamp)}
                    {note.author && ` • ${note.author}`}
                  </div>
                )}
                {index < visibleNotes.length - 1 && (
                  <hr className="note-divider" />
                )}
              </div>
            )}
            {note.type !== "process" && (
              <div>
                <div className="note-type-label">
                  <span className={`note-type-indicator ${note.type}`}>
                    {note.type === "process" ? "P" : "i"}
                  </span>
                  {note.label}
                </div>
                <div className="note-text">{note.text}</div>
                {note.timestamp && (
                  <div className="note-meta">
                    {formatTimestamp(note.timestamp)}
                    {note.author && ` • ${note.author}`}
                  </div>
                )}
                {index < visibleNotes.length - 1 && (
                  <hr className="note-divider" />
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default NoteTooltip;
